import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollExporter  {
    _originalTypeClassName = "zERP.BO.PayrollExporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollExporter.translate = translateService;
}
this.PayrollExporterKey = null;
this._key = this.PayrollExporterKey = 0; 
}

static translate: TranslateService;
_key: any;
private _PayrollExporterKey:any;
get PayrollExporterKey(): any {
    return this._PayrollExporterKey;
  }
set PayrollExporterKey(value: any) {
    this._PayrollExporterKey = value;
    this._key = value;
  }

static ExecuteGetBasicSalaryValue(data: any,codes: any): any{let details = [];
if (codes?.linq?.where()?.firstOrDefault(null) == "0" || CLMS.Framework.String.IsNullOrEmpty(codes?.linq?.where()?.firstOrDefault(null)) || CLMS.Framework.String.IsNullOrEmpty((codes?.linq?.where()?.firstOrDefault(null) ?? '').trim())) {details = data?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Basic && CLMS.Framework.Number.Equal(() => s.Salary.Priority, () => 0))?.toArray();}else {details = data?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Basic && codes?.linq?.contains(s?.Salary?.Code))?.toArray();}
return ((CLMS.Framework.Number.Equal(() => details.length, () => 0) || details == null) ? 0 : details?.linq?.sum((d) => d?.Amount));
}
static ExecuteGetEmpContributionValue(data: any,codes: any): any{let details = data?.Contributions?.linq?.where((s) => codes?.linq?.contains(s?.Rule?.Code))?.toArray();
return (details == null ? 0 : details?.linq?.sum((l) => l?.EmployeeContribution));
}
static ExecuteGetEmpDeductionValue(data: any,codes: any): any{let deduction = data?.Deductions?.linq?.where((s) => codes?.linq?.contains(s?.Rule?.Code))?.toArray();
return (deduction == null ? 0 : deduction?.linq?.sum((d) => d?.EmployeeAmount));
}
static ExecuteGetEmployerContributionValue(data: any,codes: any): any{let details = data?.Contributions?.linq?.where((s) => codes?.linq?.contains(s?.Rule?.Code))?.toArray();
return (details == null ? 0 : details?.linq?.sum((l) => l?.EmployerContribution));
}
static ExecuteGetMainSalaryValue(data: any,codes: any): any{let details = data?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Main && codes?.linq?.contains(s?.Salary?.Code))?.toArray();
return (details == null ? 0 : details?.linq?.sum((s) => s?.Amount));
}
static ExecuteGetOtherSalaryValue(data: any,codes: any): any{let details = data?.Salaries?.linq?.where((s) => s?.Salary?.RuleType == Domain.SalaryRuleType.Other && codes?.linq?.contains(s?.Salary?.Code))?.toArray();
return (details == null ? 0 : details?.linq?.sum((d) => d?.Amount));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollExporterKey == null || $this.PayrollExporterKey == 0;
            }


}